<template>
    <div v-if="visible" :class="['sub-banner', bannerType]">
        <div class="banner-content">
            <i :class="bannerIcon"></i>
            <span>{{ bannerMessage }}</span>
        </div>
        <button v-if="dismissable" @click="dismiss" class="banner-close">&times;</button>
    </div>
</template>

<script>
export default {
    name: 'SubscriptionBanner',
    data() {
        return {
            dismissed: false,
            status: '',
            trialDays: 0,
            active: true
        }
    },
    computed: {
        visible() {
            if (this.dismissed) return false
            if (!this.status) return false
            if (this.status === 'ACTIVE') return false
            if (this.status === 'TRIAL' && this.trialDays > 5) return false
            return true
        },
        bannerType() {
            if (this.status === 'SUSPENDED' || this.status === 'EXPIRED') return 'banner-danger'
            if (this.status === 'TRIAL' && this.trialDays <= 3) return 'banner-danger'
            return 'banner-warning'
        },
        bannerIcon() {
            if (this.status === 'SUSPENDED' || this.status === 'EXPIRED') return 'tim-icons icon-alert-circle-exc'
            return 'tim-icons icon-time-alarm'
        },
        bannerMessage() {
            if (this.status === 'EXPIRED') return this.$t('subscription.trialExpired') + '. ' + this.$t('subscription.contactAdmin') + '.'
            if (this.status === 'SUSPENDED') return this.$t('subscription.suspended') + '. ' + this.$t('subscription.contactAdmin') + '.'
            if (this.status === 'TRIAL') {
                if (this.trialDays <= 0) return this.$t('subscription.trialExpired') + '. ' + this.$t('subscription.contactAdmin') + '.'
                return this.$t('subscription.trialExpiring', { days: this.trialDays })
            }
            return ''
        },
        dismissable() {
            return this.status === 'TRIAL' && this.trialDays > 0
        }
    },
    created() {
        this.loadStatus()
    },
    methods: {
        loadStatus() {
            try {
                const user = JSON.parse(localStorage.getItem('fiscal_user') || '{}')
                this.status = user.subscriptionStatus || ''
                this.trialDays = user.trialDaysRemaining || 0
                this.active = user.isSubscriptionActive !== false
            } catch (e) {
                // ignore
            }
        },
        dismiss() {
            this.dismissed = true
        }
    }
}
</script>

<style scoped>
.sub-banner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 18px;
    border-radius: 10px;
    margin-bottom: 15px;
    animation: slideDown 0.3s ease;
}
@keyframes slideDown {
    from { opacity: 0; transform: translateY(-10px); }
    to { opacity: 1; transform: translateY(0); }
}
.banner-warning {
    background: #fff3cd;
    border: 1px solid #ffc107;
    color: #856404;
}
.banner-danger {
    background: #f8d7da;
    border: 1px solid #dc3545;
    color: #721c24;
}
.banner-content {
    display: flex;
    align-items: center;
    gap: 10px;
    font-size: 14px;
    font-weight: 500;
}
.banner-content i { font-size: 18px; }
.banner-close {
    background: none; border: none;
    font-size: 20px; cursor: pointer;
    color: inherit; opacity: 0.6;
    padding: 0 4px;
}
.banner-close:hover { opacity: 1; }
</style>